import * as React from 'react';
import { Skeleton } from '../skeleton/Skeleton';
import {
  LedgerAccountHeaderLayout,
  BalancesLayout,
} from '../ledger-account-header/LedgerAccountHeader.styles';
import { DataEntryTableSkeleton } from '../data-entry-table/DataEntryTableSkeleton';
import styled from 'styled-components';
import { VisuallyHidden } from '../../NewGeneralLedger.styles';

export const LoadingContainer = styled.div`
  display: grid;
  margin: 0 32px;
  width: calc(100% - 64px);
`;

const LedgerRowContainer = styled.div`
  width: 100%;
`;

type LedgerRowSkeletonProps = {
  tableRows?: number;
};

export const LedgerRowSkeleton = ({ tableRows }: LedgerRowSkeletonProps): React.ReactElement => (
  <LedgerRowContainer>
    <LedgerAccountHeaderLayout>
      <Skeleton width={100} height={20} />
      <BalancesLayout>
        <Skeleton width={100} height={16} />
      </BalancesLayout>
    </LedgerAccountHeaderLayout>
    <DataEntryTableSkeleton rows={tableRows} />
    <VisuallyHidden>Loading</VisuallyHidden>
  </LedgerRowContainer>
);

export const LedgerTableSkeleton = (): React.ReactElement => (
  <LoadingContainer>
    <LedgerRowSkeleton tableRows={13} />
    <LedgerRowSkeleton tableRows={13} />
    <LedgerRowSkeleton tableRows={13} />
    <LedgerRowSkeleton tableRows={13} />
    <LedgerRowSkeleton tableRows={13} />
    <VisuallyHidden>Loading</VisuallyHidden>
  </LoadingContainer>
);
